import React from 'react';
import PhoneInput from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';
import { classNames } from 'utils';

import 'react-phone-number-input/style.css';
import './InputPhoneIntl.scss';

export interface IInputPhoneIntl {
  value: string;
  onChange: (props?) => void;
  onBlur: (props?) => void;
  className?: string;
  disabled?: boolean;
  error?: boolean;
  countryCallingCodeEditable?: boolean;
  onCountryChange?: (country?: string) => void;
}

const InputPhoneIntl = ({
  className,
  value,
  onChange,
  onBlur,
  disabled,
  error,
  countryCallingCodeEditable,
  onCountryChange,
}: IInputPhoneIntl) => (
  <PhoneInput
    className={classNames('InputPhoneIntl', error && 'InputPhoneIntl--error', className)}
    international
    defaultCountry="US"
    countryCallingCodeEditable={countryCallingCodeEditable}
    // Default flagUrl fetches each flag from a third-party GitHub Pages host
    flags={flags}
    value={value || undefined}
    // PhoneInput emits undefined when cleared; the forms store '' and check with _.isEmpty
    onChange={(next) => onChange(next ?? '')}
    onBlur={onBlur}
    disabled={disabled}
    onCountryChange={onCountryChange}
  />
);

export default InputPhoneIntl;
